import axios, { AxiosResponse } from 'axios';
import {  Cuenta, GrupoProducto, OrdenCompra, Producto } from './suite.interfaces';
import { CommonService } from './common.services';

export class PagosService extends CommonService {


  async findCuentaBy(evento: number): Promise<Cuenta> {
    try {
      const response: AxiosResponse<Cuenta> = await axios.get(this.getServerUrl() + '/pagos/findCuentaBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findPublicKeyBy(evento: number): Promise<string> {
    try {
      const response: AxiosResponse<string> = await axios.get(this.getServerUrl() + '/pagos/findPublicKeyBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findGruposProductosBy(evento: number): Promise<GrupoProducto[]> {
    try {
      const response: AxiosResponse<GrupoProducto[]> = await axios.get(this.getServerUrl() + '/pagos/findGruposProductosBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findProductosBy(evento: number): Promise<Producto[]> {
    try {
      const response: AxiosResponse<Producto[]> = await axios.get(this.getServerUrl() + '/pagos/findProductosBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async findProductoBy(evento: number, producto:number): Promise<Producto> {
    try {
      const response: AxiosResponse<Producto> = await axios.get(this.getServerUrl() + '/pagos/findProductoBy?evento=' + evento + "&producto=" + producto, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }
  
  async findProductosDisponiblesBy(evento: number): Promise<Producto[]> {
    try {
      const response: AxiosResponse<Producto[]> = await axios.get(this.getServerUrl() + '/pagos/findProductosDisponiblesBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }  

  async findOrdenesCompraPagadasBy(evento: number, acreditado: number): Promise<OrdenCompra[]> {
    try {
      const response: AxiosResponse<OrdenCompra[]> = await axios.get(this.getServerUrl() + '/pagos/findOrdenesCompraPagadasBy?evento=' + evento + '&acreditado=' + acreditado, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }  

  async pagar(evento: number, hash:string, ordenCompra:Object): Promise<Map<string, string>> {
    try {
      const response: AxiosResponse<Map<string, string>> = await axios.post(this.getServerUrl() + '/pagos/pagar?evento=' + evento + "&hash=" + hash, ordenCompra, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }

  async procesarPagoOnline(evento: number, hash:string, ordenCompra:Object): Promise<String> {
    try {
      const ordenCompraPost = {"ordenCompra":  ordenCompra };
      const response: AxiosResponse<string> = await axios.post(this.getServerUrl() + '/pagos/procesarPagoOnline?evento=' + evento + "&hash=" + hash, ordenCompraPost, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw this.manageError(error);
    }
  }
}

